import styled from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import Heading from 'styles/typography/Heading';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;

  @media (${breakpoint.mdMax}) {
    margin-bottom: 24px;
  }
`;

export const Title = styled(Heading)`
  display: flex;
  align-items: center;
`;

export const Description = styled.p`
  font-family: ${font.graphikCond};
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0.5px;
`;
